// Environment configuration
const config = {
  development: {
    API_BASE_URL: 'http://localhost:4200/api/v1'
  },
  stage: {
    API_BASE_URL:  process.env.REACT_APP_API_BASE_URL || 'https://stage-api.quadroid.ai/api/v1'
  },
  production: {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api.quadroid.ai/api/v1'
  },
  productive: {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://qapi.produc8ive.com/api/v1'
  }
};

const environment = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';

/**
 * Get API key from localStorage
 * Falls back to environment variable if not found in localStorage
 * @returns {string|null} The API key or null if not found
 */
export const getApiKey = () => {
  try {
    // First, try to get from localStorage (set by authBridge)
    const apiKey = localStorage.getItem('api_key');
    if (apiKey) {
      return apiKey;
    }
    
    // Fallback to environment variable
    if (process.env.REACT_APP_API_KEY) {
      return process.env.REACT_APP_API_KEY;
    }
    
    console.warn('API key not found in localStorage or environment variables');
    return null;
  } catch (error) {
    console.error('Error getting API key from localStorage:', error);
    return process.env.REACT_APP_API_KEY || null;
  }
};

// Create config object with getter for API_KEY
const baseConfig = config[environment] || config.production;
const finalConfig = {
  ...baseConfig,
  // Google Drive picker credentials — both are public/safe to ship in the frontend.
  // The client secret is intentionally not used anywhere.
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY || '',
  get API_KEY() {
    return getApiKey();
  }
};

export default finalConfig;
